// extracted by mini-css-extract-plugin
export var post__footer = "Post-module--post__footer--L98TP";
export var post__content = "Post-module--post__content--2nubo";
export var post__comments = "Post-module--post__comments--21hyQ";
export var post__homeButton = "Post-module--post__home-button--33KJx";
export var post__postButton = "Post-module--post__post-button--3wgQg";